import { render, staticRenderFns } from "./ResultMission.vue?vue&type=template&id=72bb0c74&"
import script from "./ResultMission.vue?vue&type=script&lang=js&"
export * from "./ResultMission.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports